import { useState, useEffect } from "react";
import axios from "axios";
import { apibasePath } from "../config";
const BrandLogo = () => {
  const Api = `${apibasePath}/client/profiles/brand/`;
  const [brandLogo, setBrandLogo] = useState(null);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);
  return (
    <div>
      <div align="center" style={{ fontFamily: "Roboto" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h4>POWERED BY</h4>
          <div
            style={{
              width: "100px",
              height: "50px",
              borderRadius: "10px",
              overflow: "hidden",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={brandLogo}
              alt="Brandlogo"
              style={{ width: "100%", height: "100%", backgroundSize: "cover" }}
            />
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default BrandLogo;
